import {
  ACCESS_TOKEN_STORAGE_KEY,
  USER_QUERY_KEY,
} from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { userApi } from "@/api/services";

export const useGetUser = () => {
  return useQuery({
    queryKey: [USER_QUERY_KEY],
    queryFn: () => userApi.getUser(),
    retry: false,
    enabled: !!localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY),
  });
};
